import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import {
    isInArrayKey,
    formatRequestStat,
    getFileExt,
} from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'statdocs',
    templateUrl: 'statdocs.component.html',
    styleUrls: ['statdocs.component.scss'],
})
export class StatDocsComponent implements OnInit, OnChanges {
    @Input()
    @Output()
    public visible: boolean;
    @Input()
    public request: {};
    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();

    public fr: any;
    public error = false;
    public errorMessage = '';
    public statList: any[];
    public selectedStat: any[];

    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        private translate: TranslateService
    ) {
    }

    public ngOnInit() {
        this.getStatList();
    }

    public ngOnChanges() {}

    private async getStatList() {
        let wRes;
        this.statList = [];
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('getmodelstatlist', {}));
            if (wRes.ModelStatList) {
                this.statList = this.updateListStat(wRes.ModelStatList);
            }            
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Stat_List_KO'));
        }
    }
    
    private updateListStat(aData) {
        let warray = new Array();
        if (aData.ModelStat.length !== 0) {
            aData.ModelStat.forEach((item) => {
                if (Array.isArray(item.Information.Label)) {
                    item.label = item.Information.Name;
                } else {
                    item.label = item.Information.Label;
                }
                item.value = item.Information.Name;
                // item.statId = item.Document.Document;
                warray.push(item);
            });
        }
        return warray;
    }

    public onClickStat() {
        if (!this.selectedStat) {
            this._messageService.addWarnNoStick(this.translate.instant('Stat_List'));
        } else {
            this.execStat(this.statList, this.selectedStat, this.request);
        }
    }

    public async execStat(aList, aStat, aRequest) {
        let wRes: any;
        let wStatId = '';
        let wStatName = '';
        let wStatExt = '';

        wRes = isInArrayKey(aStat, aList, 'value');
        if (wRes !== undefined) {
            wStatId = wRes.Document.Document;
            wStatName = wRes.Document.DocumentName;
            wStatExt = getFileExt(wRes.Document.DocumentName);
        }

        const wParams = formatRequestStat(aStat, wStatId, aRequest, wStatExt);

        try {
            wRes = await lastValueFrom(this.api.execUrlAction('execstat', wParams));
            this._messageService.addSuccess(this.translate.instant('Batch_Send'));
            this.close(null);
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Batch_Send_KO'));
        }
    }

    public close(event) {
        this.visible = false;
        this.onClose.emit();
    }
}
